import React from 'react';
import { withPlaceholder } from 'HOC';
import { PortfolioTransactionsType } from 'services/requests';
import { useGetAllAssets } from 'hooks/api/portfolio';
import RenderTransactionsTable from './components/RenderTransactionsTable';
import { TransactionsColumnsType, mapData } from './UserTransactionsTable.columns';

const RenderTablewithPlaceholders = withPlaceholder(RenderTransactionsTable);

const defaultColumns: TransactionsColumnsType[] = [
  'assetName',
  'type',
  'orderStatus',
  'date',
  'usdAmount',
  'assetAmount',
  'madeBy',
];

type Props = {
  columns?: TransactionsColumnsType[];
  transactionsData?: PortfolioTransactionsType;
  portfolioTransactionsLoading: boolean;
  isError: boolean;
  refetch: () => void;
  isRefetching: boolean;
};

const UserTransactionsTable: React.FC<Props> = ({
  columns = defaultColumns,
  transactionsData,
  portfolioTransactionsLoading,
  isError,
  refetch,
  isRefetching,
}) => {
  const { isLoading: allAssetsLoading } = useGetAllAssets();

  const isLoading = portfolioTransactionsLoading || allAssetsLoading;

  const items = mapData(transactionsData?.items);

  const onTransactionClick = () => {};

  return (
    <RenderTablewithPlaceholders
      columns={columns}
      transactionsListData={transactionsData}
      items={items}
      onAssetClick={onTransactionClick}
      refetch={refetch}
      isRefetching={isRefetching}
      isLoading={isLoading}
      isError={isError}
      isData={true}
    />
  );
};

export default UserTransactionsTable;
